import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-55e658e4")

_pushScopeId("data-v-55e658e4")
const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "table__header row__wrapper row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "header__cell cell cell--info cell--data",
  title: "Filtrer les match"
}, [
  /*#__PURE__*/_createVNode("span", { class: "filter__trig" }, [
    /*#__PURE__*/_createVNode("i", { class: "icon-info-circled" }),
    /*#__PURE__*/_createTextVNode("Match ")
  ])
], -1)
const _hoisted_4 = { class: "filter__trig" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-calendar" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Date ")
const _hoisted_7 = {
  key: 0,
  class: "icon-filter"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "header__cell cell cell--time cell--data" }, [
  /*#__PURE__*/_createVNode("span", null, [
    /*#__PURE__*/_createVNode("i", { class: "icon-clock" }),
    /*#__PURE__*/_createTextVNode(" Heure ")
  ])
], -1)
const _hoisted_9 = { class: "filter__trig" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-location" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Terrain ")
const _hoisted_12 = {
  key: 0,
  class: "icon-filter"
}
const _hoisted_13 = { class: "filter__trig" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "icon-team" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Équipes ")
const _hoisted_16 = {
  key: 0,
  class: "icon-filter"
}
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<br data-v-55e658e4><span class=\"team__home\" data-v-55e658e4><span class=\"team__home--long\" data-v-55e658e4>Local</span><span class=\"team__home--short\" title=\"Local\" data-v-55e658e4>Loc.</span> – <span class=\"team__home--long\" data-v-55e658e4>Visiteur</span><span class=\"team__home--short\" title=\"Visiteurs\" data-v-55e658e4>Vis.</span></span>", 2)
const _hoisted_19 = { class: "filter__trig" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "icon-tree" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Division ")
const _hoisted_22 = {
  key: 0,
  class: "icon-filter"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "header__cell cell cell--edit" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "table__body table__body--empty scrollbar--invisible"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }),
  /*#__PURE__*/_createTextVNode("Chargement...")
], -1)
const _hoisted_26 = {
  key: 1,
  class: "table__body table__body--empty scrollbar--invisible"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-filter" }),
  /*#__PURE__*/_createTextVNode("Aucun match")
], -1)
const _hoisted_28 = {
  key: 2,
  ref: "schedule",
  class: "table__body scrollbar--invisible"
}
const _hoisted_29 = { class: "cell cell--info cell--data" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "icon-clock" }, null, -1)
const _hoisted_33 = { key: 5 }
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "icon-location" }, null, -1)
const _hoisted_35 = { class: "cell cell--date cell--data" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "cell cell--time cell--data" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "cell cell--field cell--data" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "icon-location" }, null, -1)
const _hoisted_42 = { class: "cell cell--team" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "delimiter lighter" }, "–", -1)
const _hoisted_44 = {
  key: 0,
  class: "cell--result"
}
const _hoisted_45 = { class: "team-name team-name--right" }
const _hoisted_46 = {
  key: 0,
  class: "delimiter"
}
const _hoisted_47 = { class: "team-name team-name--left" }
const _hoisted_48 = {
  key: 1,
  class: "result--cancelled"
}
const _hoisted_49 = { class: "cancelled--checkbox" }
const _hoisted_50 = /*#__PURE__*/_createVNode("span", null, "Annulé", -1)
const _hoisted_51 = {
  key: 0,
  class: "cancelled--reason"
}
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Raison: ")
const _hoisted_53 = {
  key: 2,
  class: "cell--result"
}
const _hoisted_54 = {
  key: 0,
  class: "match-cancelled"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "icon-clear" }, null, -1)
const _hoisted_56 = {
  key: 1,
  class: "delimiter"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("span", null, " ", -1)
const _hoisted_58 = { class: "cell cell--division cell--data" }
const _hoisted_59 = { class: "cell cell--edit" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = /*#__PURE__*/_createVNode("i", {
  class: "icon-attention-circled",
  title: "Match non-homologué"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")
  const _component_router_link = _resolveComponent("router-link")
  const _component_TeamLabel = _resolveComponent("TeamLabel")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")
  const _component_TheAvailableTimeslots = _resolveComponent("TheAvailableTimeslots")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        class: "header__cell cell cell--date cell--data",
        title: "Filtrer par date",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showScheduleFilter && _ctx.showScheduleFilter(...args)), ["stop"]))
      }, [
        _createVNode("span", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          (_ctx.hasDateFilterApplied)
            ? (_openBlock(), _createBlock("i", _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_8,
      _createVNode("div", {
        class: "header__cell cell cell--field cell--data",
        title: "Filtrer par terrain",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showScheduleFilter && _ctx.showScheduleFilter(...args)), ["stop"]))
      }, [
        _createVNode("span", _hoisted_9, [
          _hoisted_10,
          _hoisted_11,
          (_ctx.hasFieldFilterApplied)
            ? (_openBlock(), _createBlock("i", _hoisted_12))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", {
        class: "header__cell cell cell--team",
        title: "Filtrer par équipe",
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showScheduleFilter && _ctx.showScheduleFilter(...args)), ["stop"]))
      }, [
        _createVNode("span", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          (_ctx.hasTeamFilterApplied)
            ? (_openBlock(), _createBlock("i", _hoisted_16))
            : _createCommentVNode("", true),
          _hoisted_17
        ])
      ]),
      _createVNode("div", {
        class: "header__cell cell cell--division cell--data",
        title: "Filter par division",
        onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showScheduleFilter && _ctx.showScheduleFilter(...args)), ["stop"]))
      }, [
        _createVNode("span", _hoisted_19, [
          _hoisted_20,
          _hoisted_21,
          (_ctx.hasDivisionFilterApplied)
            ? (_openBlock(), _createBlock("i", _hoisted_22))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_23
    ]),
    (_ctx.scheduleLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_24, [
          _hoisted_25
        ]))
      : (_ctx.filteringEverything)
        ? (_openBlock(), _createBlock("div", _hoisted_26, [
            _hoisted_27
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_28, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedFilteredSchedule, (match, ix) => {
              return (_openBlock(), _createBlock("div", {
                key: match._id,
                class: ["row__wrapper", {
                    'row--selected': _ctx.isSelected(ix),
                    'row--delimiter': _ctx.isBeforeNextMatch(match, ix),
                    'row--first-of-week': _ctx.isFirstOfWeek(match)
                }],
                onClick: _withModifiers(($event: any) => (_ctx.selectRow(ix)), ["stop"])
              }, [
                _createVNode("div", {
                  class: ["row", {
                        'row--cancelled': _ctx.wasCancelled(match)
                    }],
                  title: _ctx.awaitingApproval(match)? 'Match non-homologué': ''
                }, [
                  _createVNode("div", _hoisted_29, [
                    (_ctx.canUpdateMatch && _ctx.isEditing(match))
                      ? (_openBlock(), _createBlock(_component_Datepicker, {
                          key: 0,
                          modelValue: _ctx.editMatchDateSelected,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.editMatchDateSelected = $event))
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock("span", _hoisted_30, _toDisplayString(_ctx.formattedDate(match.date)), 1)),
                    (_ctx.canUpdateMatch && _ctx.isEditing(match))
                      ? _withDirectives((_openBlock(), _createBlock("select", {
                          key: 2,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.editMatchTimeSelected = $event))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableTime, (time, ix) => {
                            return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(time), 1))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, _ctx.editMatchTimeSelected]
                        ])
                      : (_openBlock(), _createBlock("span", _hoisted_31, [
                          _hoisted_32,
                          _createTextVNode(_toDisplayString(_ctx.formattedTime(match.date)), 1)
                        ])),
                    (_ctx.canUpdateMatch && _ctx.isEditing(match))
                      ? _withDirectives((_openBlock(), _createBlock("select", {
                          key: 4,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.editMatchFieldSelected = $event))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedFields, (field, ix) => {
                            return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(field), 1))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, _ctx.editMatchFieldSelected]
                        ])
                      : (_openBlock(), _createBlock("span", _hoisted_33, [
                          _createVNode(_component_router_link, {
                            to: `/fields#${match.field? encodeURI(match.field): ''}`
                          }, {
                            default: _withId(() => [
                              _hoisted_34,
                              _createTextVNode(" " + _toDisplayString(match.field ?? 'TBD'), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                  ]),
                  _createVNode("div", _hoisted_35, [
                    (_ctx.canUpdateMatch && _ctx.isEditing(match))
                      ? (_openBlock(), _createBlock(_component_Datepicker, {
                          key: 0,
                          modelValue: _ctx.editMatchDateSelected,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.editMatchDateSelected = $event))
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock("span", _hoisted_36, _toDisplayString(_ctx.formattedDate(match.date)), 1))
                  ]),
                  _createVNode("div", _hoisted_37, [
                    (_ctx.canUpdateMatch && _ctx.isEditing(match))
                      ? _withDirectives((_openBlock(), _createBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.editMatchTimeSelected = $event))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableTime, (time, ix) => {
                            return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(time), 1))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, _ctx.editMatchTimeSelected]
                        ])
                      : (_openBlock(), _createBlock("span", _hoisted_38, _toDisplayString(_ctx.formattedTime(match.date)), 1))
                  ]),
                  _createVNode("div", _hoisted_39, [
                    (_ctx.canUpdateMatch && _ctx.isEditing(match))
                      ? _withDirectives((_openBlock(), _createBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.editMatchFieldSelected = $event))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedFields, (field, ix) => {
                            return (_openBlock(), _createBlock("option", { key: ix }, _toDisplayString(field), 1))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, _ctx.editMatchFieldSelected]
                        ])
                      : (_openBlock(), _createBlock("span", _hoisted_40, [
                          _createVNode(_component_router_link, {
                            to: `/fields#${match.field? encodeURI(match.field): ''}`
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(match.field ?? 'TBD') + " ", 1),
                              _hoisted_41
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                  ]),
                  _createVNode("div", _hoisted_42, [
                    _createVNode("div", {
                      class: ["cell--team-name", {'team-name--stacked': _ctx.seriesMatchUnknown(match) || _ctx.smallWindow}]
                    }, [
                      _createVNode(_component_TeamLabel, {
                        class: "team-name team-name--right",
                        team: _ctx.homeTeam(match),
                        teamName: true,
                        alt: _ctx.homeTeam(match) || !match.homeRank? '': _ctx.homeMatchAlt(match),
                        invert: _ctx.smallWindow? false: true,
                        badge: !!_ctx.homeTeam(match)
                      }, null, 8, ["team", "alt", "invert", "badge"]),
                      _hoisted_43,
                      _createVNode(_component_TeamLabel, {
                        class: "team-name team-name--left",
                        team: _ctx.awayTeam(match),
                        teamName: true,
                        alt: _ctx.awayTeam(match) || !match.awayRank? '': _ctx.awayMatchAlt(match),
                        invert: false,
                        badge: !!_ctx.awayTeam(match)
                      }, null, 8, ["team", "alt", "badge"])
                    ], 2),
                    ((_ctx.canUpdateMatchResult(match) || _ctx.canUpdateMatch) && _ctx.isEditing(match))
                      ? (_openBlock(), _createBlock("div", _hoisted_44, [
                          _createVNode("span", _hoisted_45, [
                            (_ctx.editMatchCancelled === '')
                              ? _withDirectives((_openBlock(), _createBlock("input", {
                                  key: 0,
                                  class: "result--input",
                                  type: "number",
                                  max: "99",
                                  min: "0",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.editMatchHomeScore = $event))
                                }, null, 512)), [
                                  [_vModelText, _ctx.editMatchHomeScore]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.editMatchCancelled === '')
                            ? (_openBlock(), _createBlock("span", _hoisted_46, " "))
                            : _createCommentVNode("", true),
                          _createVNode("span", _hoisted_47, [
                            (_ctx.editMatchCancelled === '')
                              ? _withDirectives((_openBlock(), _createBlock("input", {
                                  key: 0,
                                  class: "result--input",
                                  type: "number",
                                  max: "99",
                                  min: "0",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.editMatchAwayScore = $event))
                                }, null, 512)), [
                                  [_vModelText, _ctx.editMatchAwayScore]
                                ])
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canUpdateMatch && _ctx.isEditing(match) && _ctx.canCancelMatch)
                      ? (_openBlock(), _createBlock("div", _hoisted_48, [
                          _createVNode("div", _hoisted_49, [
                            _createVNode(_component_Checkbox, {
                              checked: _ctx.editMatchCancelled !== '',
                              value: "Annulé",
                              onToggle: _ctx.toggleMatchCancelled
                            }, {
                              default: _withId(() => [
                                _hoisted_50
                              ]),
                              _: 1
                            }, 8, ["checked", "onToggle"])
                          ]),
                          (_ctx.editMatchCancelled !== '')
                            ? (_openBlock(), _createBlock("div", _hoisted_51, [
                                _hoisted_52,
                                _withDirectives(_createVNode("input", {
                                  class: "cancelled--input",
                                  type: "text",
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.editMatchCancelled = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.editMatchCancelled]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.hasResult(match) && !_ctx.isEditing(match))
                      ? (_openBlock(), _createBlock("div", _hoisted_53, [
                          _createVNode("span", {
                            class: ["team-name team-name--right", {'result--winner': _ctx.homeTeamResult(match) > _ctx.awayTeamResult(match)}]
                          }, _toDisplayString(_ctx.formattedResult(match).homeTeam), 3),
                          (_ctx.wasCancelled(match))
                            ? (_openBlock(), _createBlock("span", _hoisted_54, [
                                _hoisted_55,
                                _createTextVNode(" " + _toDisplayString(match.result?.cancelled), 1)
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_56, [
                                _hoisted_57
                              ])),
                          _createVNode("span", {
                            class: ["team-name team-name--left", {'result--winner': _ctx.awayTeamResult(match) > _ctx.homeTeamResult(match)}]
                          }, _toDisplayString(_ctx.formattedResult(match).awayTeam), 3)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_58, [
                    _createVNode("span", null, _toDisplayString(_ctx.divisionDisplay(match)), 1)
                  ]),
                  _createVNode("div", _hoisted_59, [
                    (_ctx.canUpdateMatchResult(match) || _ctx.canUpdateMatch)
                      ? (_openBlock(), _createBlock("div", _hoisted_60, [
                          _createVNode("span", null, [
                            (_ctx.isEditing(match))
                              ? (_openBlock(), _createBlock("i", {
                                  key: 0,
                                  title: "Sauvegarder les modifications",
                                  class: "icon-upload",
                                  onClick: ($event: any) => (_ctx.saveEdits(match))
                                }, null, 8, ["onClick"]))
                              : (_openBlock(), _createBlock("i", {
                                  key: 1,
                                  title: "Modifier le match",
                                  class: "edit--logo icon-sketch",
                                  onClick: ($event: any) => (_ctx.editMatch(match))
                                }, null, 8, ["onClick"]))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", null, [
                      (_ctx.isEditing(match))
                        ? (_openBlock(), _createBlock("i", {
                            key: 0,
                            class: "icon-cancel-circled",
                            title: "Annuler les modifications",
                            onClick: ($event: any) => (_ctx.cancelEdits(match))
                          }, null, 8, ["onClick"]))
                        : (_ctx.canUpdateMatch)
                          ? (_openBlock(), _createBlock(_component_ConfirmAction, {
                              key: 1,
                              type: "delete",
                              onConfirm: ($event: any) => (_ctx.removeMatch(match._id))
                            }, null, 8, ["onConfirm"]))
                          : (_ctx.canUpdateMatchResult(match) && _ctx.canApproveMatchResult(match))
                            ? (_openBlock(), _createBlock(_component_ConfirmAction, {
                                key: 2,
                                type: "ok",
                                onConfirm: ($event: any) => (_ctx.approveMatch(match._id))
                              }, null, 8, ["onConfirm"]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.awaitingApproval(match))
                      ? (_openBlock(), _createBlock("div", _hoisted_61, [
                          _hoisted_62
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.canRequestTimeslot(match))
                      ? (_openBlock(), _createBlock("i", {
                          key: 2,
                          title: "Planifier la reprise",
                          class: "icon-calendar edit--logo",
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.toggleAvailableTimeslots && _ctx.toggleAvailableTimeslots(...args)))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ], 10, ["title"]),
                (_ctx.showAvailableTimeslots && _ctx.isSelected(ix) && _ctx.canRequestTimeslot(match))
                  ? (_openBlock(), _createBlock(_component_TheAvailableTimeslots, {
                      key: 0,
                      match: _ctx.selectedMatch,
                      booked: false
                    }, null, 8, ["match"]))
                  : _createCommentVNode("", true)
              ], 10, ["onClick"]))
            }), 128))
          ], 512))
  ]))
})